import ko from "knockout";
import $ from "jquery";
import register from "flow/knockout/register";

const usertag = $(".lc-usertag-container");
const usertagPopover = $(".lc-user-tag-popover");

register.registerKnockoutBinding("usertagPopover", {
    init: function () {
        $("body").on("click", function (e) {
            const target = $(e.target);

            if (
                !target.parents(".lc-usertag-container").is(usertag) &&
                !target.parents(".lc-user-tag-popover").is(usertagPopover)
            ) {
                const vm = ko.dataFor($("body")[0]);
                vm.userContextTabs.isExpanded(false);
            }
        });
    },
    update: function (_element, valueAccessor) {
        if (!valueAccessor()()) {
            usertag.removeClass("active");
            usertagPopover.removeClass("show");
        } else {
            const usertagPos = $(".lc-usertag-expander").position();
            usertagPopover.css("top", usertagPos.top + 45);

            usertag.addClass("active");
            usertagPopover.addClass("show");
        }
    }
});
